import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/pro-regular-svg-icons';
import { Dropdown, DropdownToggle, Icon, Tooltip } from '@patternfly/react-core';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import Authorized from '../../components/security/Authorized';
import { Permission } from '../../enums/permission.enum';

export default function Setup() {
	const navigate = useNavigate();
	return (
		<Authorized by={Permission.CanViewSetupPage}>
			<Tooltip
				aria="none"
				content={'Setup'}
				flipBehavior={['bottom', 'bottom-end']}
			>
				<Dropdown
					position="right"
					isText
					isPlain
					style={{
						height: '1.5rem',
						borderRadius: '50%',
					}}
					toggle={
						<DropdownToggle
							className="no-color-override"
							toggleIndicator={null}
							onToggle={() => navigate('/setup')}
							id="cog-dropdown"
							aria-label="Setup"
							icon={
								<Icon
									onClick={() => navigate('/setup')}
									style={{
										width: '2rem',
										height: '1.5rem',
										color: '#000000',
										cursor: 'pointer',
									}}
									size="lg"
									alt={'Setup'}
									aria-label="Setup"
									isInline
									data-testid="user-cog-dropdown"
								>
									<FontAwesomeIcon icon={faCog} />
								</Icon>
							}
						></DropdownToggle>
					}
				/>
			</Tooltip>
		</Authorized>
	);
}
